@if (showLoadingIndicator || ajaxLoading) {
  <div class="spinnerLayer">
    <div class="spinner"></div>
  </div>
}

<router-outlet></router-outlet>
